import { useState } from "react";
import { ChevronDown } from "lucide-react";

export type FinanceExplorerChoice = { value: string | null; label: string };

/** Explicit checkboxes work on desktop and touch without modifier-key selection. */
export function FinanceExplorerFilter({ label, options, values, onChange }: {
  label: string;
  options: FinanceExplorerChoice[];
  values: Array<string | null> | undefined;
  onChange: (values: Array<string | null> | undefined) => void;
}) {
  const [search, setSearch] = useState("");
  const matching = options.filter((option) => option.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()));
  const shown = matching.slice(0, 100);
  return <details className="fin-filter">
    <summary><span>{label} · {values?.length ? `${values.length} selected` : "All"}</span><ChevronDown size={13} aria-hidden="true" /></summary>
    <fieldset aria-label={`Filter ${label}`}>
      <legend className="sr-only">{label}</legend>
      <label className="fin-filter-search">Search {label.toLocaleLowerCase()}<input aria-label={`Search ${label}`} type="search" value={search} onChange={(event) => setSearch(event.target.value)} /></label>
      <button type="button" className="fin-filter-all" onClick={() => onChange(undefined)}>Show all {label.toLocaleLowerCase()}</button>
      <p className="fin-filter-hint">Select one or more to narrow this view.</p>
      <div className="fin-filter-options">
        {shown.map((option) => <label key={JSON.stringify(option.value)} className="fin-filter-option">
          <input type="checkbox" checked={values?.includes(option.value) ?? false} onChange={(event) => {
            const next = event.target.checked ? [...(values ?? []), option.value] : (values ?? []).filter((value) => value !== option.value);
            onChange(next.length ? next : undefined);
          }} />
          <span className="break-words">{option.label}</span>
        </label>)}
        {shown.length === 0 && <p className="fin-filter-hint">No matching choices.</p>}
      </div>
      {matching.length > shown.length && <p className="fin-filter-hint">Showing the first {shown.length} of {matching.length}. Refine the search to find more.</p>}
    </fieldset>
  </details>;
}
